/*
Module Name :      Loader
File Name   :      loader.jsx
Project     :      OrasiMedaia.com
Copyright (c)      peafowl.inc
author      :     chandrasekhar
author      :
license     :
version     :      0.0.12 // written by  for present.
Created on  :      4th January 2023
Last modified on:  12th January 2023
Description :      
Organisation:      Peafowl inc.
*/

import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const Loader = () => {
    const history = useHistory();
   
    return (

        <>

            <div className="orasi-preloader">
                <img src="https://main.dc0s25wba8poy.amplifyapp.com/static/media/logo.f261173d427d12373508.jpg" />
            </div>

        </>
    );
};


export default Loader;



